<template>
  <div>
    <TextLinkList
      v-for="(textLinkListProp, index) in textLinkListProps"
      :key="index"
      v-bind="textLinkListProp"
    />
  </div>
</template>
<script>
import TextLinkList from '../../components/molecules/text_link_lists/TextLinkList'
export default {
  components: { TextLinkList },
  props: {
    textLinkListProps: {
      type: Array,
      required: true
    }
  }
}
</script>
